import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 51扒瓜网';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pb-20 px-4 md:px-8 lg:px-12 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20editorial%20office%20with%20large%20windows%2C%20warm%20natural%20light%2C%20computer%20workstations%2C%20team%20collaboration%20space%2C%20clean%20minimalist%20design%2C%20professional%20atmosphere%2C%20warm%20tones%2C%20editorial%20photography&width=1600&height=600&seq=about-hero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-50/90 to-background-50" />
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 text-primary-700 text-sm font-medium mb-6">
            <i className="ri-heart-line" />
            关于 51扒瓜网
          </span>
          <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl text-foreground-950 leading-tight mb-5">
            专注娱乐八卦
            <br />
            <span className="text-primary-600">做最有态度的吃瓜平台</span>
          </h1>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            51扒瓜网创立于2020年，是国内领先的娱乐八卦与网络热点追踪平台。我们坚持独立、客观、深度的内容态度，为千万瓜友提供最新、最真、最劲爆的娱乐资讯。
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { number: '500万+', label: '月均访问量' },
            { number: '15,000+', label: '累计发布文章' },
            { number: '200万+', label: '社交媒体粉丝' },
            { number: '98%', label: '读者满意度' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <p className="font-heading font-black text-2xl md:text-3xl text-primary-600 mb-1">{stat.number}</p>
              <p className="text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Brand Story */}
      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
                品牌故事
              </h2>
              <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
                <p>
                  51扒瓜网诞生于一群资深娱乐记者的初心。我们厌倦了千篇一律的通稿和毫无营养的八卦，决心打造一个真正有价值、有态度的娱乐资讯平台。
                </p>
                <p>
                  "扒瓜"二字取自网络用语"吃瓜群众"，寓意我们不仅要做看客，更要做那个把瓜皮剥开、让真相显露的人。五年来，我们始终坚守这一理念。
                </p>
                <p>
                  从最初的三人小团队，发展到如今拥有三十余位专业编辑、记者和业内通讯员的内容矩阵，51扒瓜网已成为华语娱乐资讯领域不可忽视的声音。
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20editorial%20team%20meeting%20in%20modern%20office%2C%20diverse%20group%20of%20young%20professionals%20discussing%20around%20table%2C%20warm%20natural%20lighting%2C%20collaborative%20atmosphere%2C%20clean%20minimalist%20interior%2C%20editorial%20photography&width=600&height=500&seq=about-team&orientation=portrait"
                alt="51扒瓜网团队"
                className="w-full h-72 md:h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              我们的价值观
            </h2>
            <p className="text-base text-foreground-600">
              三大核心原则，定义51扒瓜网的每一次内容产出
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: 'ri-shield-check-line',
                title: '真实可信',
                desc: '每一条爆料都经过至少两个独立信源交叉验证，拒绝凭空捏造和恶意炒作。真实是我们的生命线。',
                color: 'bg-primary-500',
              },
              {
                icon: 'ri-flashlight-line',
                title: '快速独家',
                desc: '与圈内资深人士保持紧密联系，确保第一时间获取独家猛料。速度是我们的竞争力。',
                color: 'bg-accent-500',
              },
              {
                icon: 'ri-thumb-up-line',
                title: '客观中立',
                desc: '不带粉丝滤镜，不站队任何一方。我们呈现事实，让读者自己形成判断。公正是我们的底线。',
                color: 'bg-secondary-500',
              },
            ].map((val, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
                <div className={`w-12 h-12 rounded-xl ${val.color} flex items-center justify-center mb-5`}>
                  <i className={`${val.icon} text-background-50 text-xl`} />
                </div>
                <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">{val.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team / Reputation */}
      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
            行业口碑
          </h2>
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 relative">
            <div className="absolute top-4 left-6 text-6xl text-primary-300 font-serif leading-none">"</div>
            <blockquote className="relative z-10 pt-6">
              <p className="text-lg md:text-xl text-foreground-800 leading-relaxed mb-6 font-medium">
                在众多娱乐资讯平台中，51扒瓜网是唯一一个我愿意推荐给朋友的。他们的报道不仅有料，更有分寸。知道什么该报、什么不该报，这种职业操守在这个行业尤为珍贵。
              </p>
              <footer className="flex items-center gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20journalist%20portrait%2C%20mature%20confident%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20business%20casual%20style%2C%20editorial%20headshot&width=80&height=80&seq=about-avatar&orientation=squarish"
                  alt="资深媒体人"
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">张主编</p>
                  <p className="text-xs text-foreground-500">资深媒体人 · 前知名娱乐杂志总编辑</p>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-base text-foreground-600">
              有爆料线索？商务合作？或者只是想聊聊？随时与我们联系
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                icon: 'ri-mail-line',
                title: '电子邮箱',
                value: 'hello@rkldzswyxgs.com',
                desc: '商务合作与投稿',
              },
              {
                icon: 'ri-mail-send-line',
                title: '爆料邮箱',
                value: 'hello@rkldzswyxgs.com',
                desc: '匿名爆料与线索提供',
              },
              {
                icon: 'ri-map-pin-line',
                title: '办公地址',
                value: '北京市朝阳区建国路88号SOHO现代城D座1808室',
                desc: '来访请提前预约',
              },
            ].map((item, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-primary-600 text-lg`} />
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-800 mb-2">{item.value}</p>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* Contact Form */}
          <div className="mt-10 bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
            <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-6">给我们留言</h3>
            <form
              id="contact-form"
              className="space-y-5"
              onSubmit={(e) => {
                e.preventDefault();
                const hp = (e.currentTarget as HTMLFormElement).querySelector('[name="company_alt"]') as HTMLInputElement;
                if (hp && hp.value.trim()) {
                  return;
                }
                alert('感谢您的留言！我们会尽快回复。');
                (e.currentTarget as HTMLFormElement).reset();
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">留言主题</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                  placeholder="请输入留言主题"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none"
                  placeholder="请输入您的留言内容（不超过500字）"
                />
                <p className="text-xs text-foreground-500 mt-1">最多500字</p>
              </div>
              {/* Honeypot */}
              <div className="hp-field">
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors"
              >
                <i className="ri-send-plane-line" />
                提交留言
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
            准备好一起扒瓜了吗？
          </h2>
          <p className="text-base text-foreground-600 mb-8 max-w-lg mx-auto">
            回到首页，探索最新娱乐八卦与网络热点，开启你的吃瓜之旅。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line" />
            返回首页
          </Link>
        </div>
      </section>

      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '51扒瓜网',
          url: 'http://rkldzswyxgs.com/',
          logo: 'http://rkldzswyxgs.com/logo.png',
          description: '全天候追踪娱乐圈最新八卦和网络热点，独家挖掘大瓜猛料',
          sameAs: ['http://rkldzswyxgs.com/'],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: '客户服务',
            email: 'hello@rkldzswyxgs.com',
            availableLanguage: 'Chinese',
          },
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'CN',
            addressLocality: '北京市朝阳区',
            streetAddress: '建国路88号SOHO现代城D座1808室',
          },
        })}
      </script>

      {/* WebPage Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '关于我们 - 51扒瓜网',
          description: '了解51扒瓜网的品牌故事、价值观和联系方式',
          url: 'http://rkldzswyxgs.com/about',
          isPartOf: {
            '@type': 'WebSite',
            name: '51扒瓜网',
            url: 'http://rkldzswyxgs.com/',
          },
          about: {
            '@type': 'Organization',
            name: '51扒瓜网',
          },
        })}
      </script>

      {/* BreadcrumbList Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'http://rkldzswyxgs.com/',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '关于我们',
              item: 'http://rkldzswyxgs.com/about',
            },
          ],
        })}
      </script>

      <Footer />
    </div>
  );
}
